module.exports = __webpack_public_path__ + "static/media/Leafeon_gaussian2.46fd75f0.png";